import * as React from 'react';
import { Text } from 'library';
import { Grid, styled } from '@mui/material';

export default function SignUpLoginContainer({ children }: { children: React.ReactNode }) {
    return <Container container>{children}</Container>;
}

const Container = styled(Grid)({
    paddingTop: 5,
});
